import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const AddAddressMutation = graphql(
  gql`
    mutation createAddress($address: UserAddressInput!) {
      createUserAddress(address: $address) {
        first_name
      }
    }
  `,
  {
    name: 'addNewAddress'
  }
)

export const CreatePaymentIntentMutation = graphql(
  gql`
    mutation createPaymentIntent($orderObj: OrderInput!) {
      createPaymentIntent(order: $orderObj) {
        paymentClientSecret
        intentId
      }
    }
  `,
  {
    name: 'createPaymentIntent'
  }
)

export const PlaceOrderMutation = graphql(
  gql`
    mutation charge($orderObj: OrderInput!) {
      charge(order: $orderObj) {
        id
        short_id
        created_at
        client_secret
        totalAmount: total_amount
        taxFee: tax
        shippingAmount: shipping_amount
        currency {
          shortName: short_name
        }
        cart {
          product {
            id
            mpn
            name
            shortDescription: short_description
          }
          itemDetails {
            label
            quantity
          }
          designId
          designName
          designOwner
          unitPrice
          productTotal
        }
      }
    }
  `,
  {
    name: 'placeOrder'
  }
)

export const CurrencyQuery = gql`
  query currency($countryCode: String!) {
    currency: currencyByCountryCode(code: $countryCode)
  }
`

export const getDesignsByShortIdsQuery = gql`
  query getDesignsByShortIds($ids: [String]) {
    getDesignsByShortIds(ids: $ids) {
      short_id
      created_at
    }
  }
`

export const AddCardMutation = graphql(
  gql`
    mutation addCardSourceStripeCustomer($token: String!) {
      addCardSourceStripeCustomer(token: $token) {
        id
      }
    }
  `,
  {
    name: 'addNewCard'
  }
)

export const isScaPaymentQuery = gql`
  query isScaPayment($code: String!) {
    subsidiarySCA: isScaPayment(code: $code) {
      subsidiary
      sca
    }
  }
`

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile(checkout: true) {
      userProfile {
        firstName: first_name
        lastName: last_name
        phone
        invoiceEnabled: invoice_enabled
        invoiceTerms: invoice_terms
        forceRemoveCart: force_remove_cart
      }
      reseller {
        status
        currency
        comission
      }
    }
    notificationData: getProfileNotificationSettings {
      notifyOrderPayment: notify_order_payment
      notifyProDesign: notify_pro_design
      notifyProductService: notify_product_service
      notifyTeamStore: notify_team_store
      notifyDesignLab: notify_design_lab
      notifyComments: notify_comments
      newsletterSubscribed: newsletter_subscribed
    }
  }
`

export const getDesignLabInfo = gql`
  query getDesignLabInfo($teamStoreId: String, $printOption: String, $onlyEvo: Boolean, $fromCA: Boolean) {
    getDesignLabInfo {
      underMaintenance: under_maintenance
    }
    deliveryDateExtended: getDeliveryDateExtended(
      teamStoreId: $teamStoreId, 
      printOption: $printOption, 
      onlyEvo: $onlyEvo,
      fromCA: $fromCA
    ) {
      deliveryDate
      bulkShipAddress {
        firstName
        lastName
        street
        apartment
        country
        stateProvince
        stateProvinceCode
        city
        zipCode
        defaultShipping
        defaultBilling
        phone
      }
      mandatory
      bulkShipPrivate
      bulkShipOption
      isStoreOwner
      totalWeight
    }
    designReviewPrices: getDesignReviewPrices {
      usd
      aud
      cad
      eur
      chf
      gbp
    }
    testPrintPrices: getTestPrintPrices {
      usd
      aud
      cad
      eur
      chf
      gbp
    }
  }
`

export const UpdateNotificationSettingMutation = graphql(
  gql`
    mutation updateNotification($setting: String!, $value: Int!) {
      setNotificationSetting(setting: $setting, value: $value) {
        message
      }
    }
  `,
  {
    name: 'updateNotification'
  }
)

export const UpdatePhoneSettingMutation = graphql(
  gql`
    mutation changeUserPhone($userId: String!, $phone: String!) {
      profile: changeUserPhone(userId: $userId, phone: $phone) {
        phone
      }
    }
  `,
  {
    name: 'updatePhone'
  }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Checkout/data.ts